import { schemas } from "@convergence/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetch } from "../fetch";

const connectedAppsKey = ["connectedApps"];

export async function getConnectedApps() {
  return fetch("/auth/connected-apps", { method: "GET" }, schemas.ConnectedAppsResponse);
}

export async function revokeConnectedApp(clientId: string) {
  return fetch(
    `/auth/connected-apps/${encodeURIComponent(clientId)}`,
    { method: "DELETE" },
    schemas.SuccessDto,
  );
}

export const useConnectedAppsQuery = () => {
  return useQuery({ queryKey: connectedAppsKey, queryFn: getConnectedApps });
};

export const useRevokeConnectedAppMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeConnectedApp,
    onSettled: () => queryClient.invalidateQueries({ queryKey: connectedAppsKey }),
  });
};
